import { IncomeSplitConfigCreatedVia, MoneyMapStatus } from '@fruitful/types';

export enum MoneyMapGuideReadableStatus {
    DRAFT = 'DRAFT',
    PUBLISHED = 'PUBLISHED',
    FINALIZED = 'FINALIZED',
    ARCHIVED = 'ARCHIVED',
}

export const MoneyMapGuideReadableStatusMap: Record<MoneyMapStatus, string> = {
    [MoneyMapStatus.DRAFT]: MoneyMapGuideReadableStatus.DRAFT,
    [MoneyMapStatus.PREVIEW]: MoneyMapGuideReadableStatus.PUBLISHED,
    [MoneyMapStatus.ACTIVE]: MoneyMapGuideReadableStatus.FINALIZED,
    [MoneyMapStatus.INACTIVE]: MoneyMapGuideReadableStatus.ARCHIVED,
    [MoneyMapStatus.DELETED]: 'DELETED',
};

export const IncomeSplitCreatedViaLabelMap: Record<
    IncomeSplitConfigCreatedVia,
    string
> = {
    [IncomeSplitConfigCreatedVia.MEMBER_MONEY_MAP_EDIT]: 'Via - member mm edit',
    [IncomeSplitConfigCreatedVia.MONEY_MAP_PROPOSAL_ACCEPTED]: 'Via - go flow',
    [IncomeSplitConfigCreatedVia.INCOME_SPLIT_EDITOR]:
        'Via - income split edit',
};

export const getIncomeSplitCreatedViaLabel = (
    createdVia: IncomeSplitConfigCreatedVia | null,
): string | null =>
    createdVia == null ? null : IncomeSplitCreatedViaLabelMap[createdVia];
